/* eslint-disable react/no-unescaped-entities */
import { Box, Button, Modal, ModalProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Container } from './style';

type ConfirmModalProps = {
  isOpen: boolean;
  yesAction?: () => void;
  noAction?: () => void;
  title: string;
  description?: string;
  children?: React.ReactNode;
  sx?: any;
  childSx?: any;
  modalProps?: ModalProps;
};

export default function ConfirmModal({
  isOpen,
  yesAction,
  noAction,
  title,
  description,
  children,
  sx,
  childSx,
  modalProps,
}: ConfirmModalProps) {

  const { disableEscapeKeyDown, disableAutoFocus, disableEnforceFocus, disableRestoreFocus, onBackdropClick } = modalProps || {};

  const { t } = useTranslation('common');

  return (
    <Modal open={isOpen}
      onClose={disableEscapeKeyDown ? undefined : noAction}
      disableEscapeKeyDown={disableEscapeKeyDown}
      disableAutoFocus={disableAutoFocus}
      disableEnforceFocus={disableEnforceFocus}
      disableRestoreFocus={disableRestoreFocus}
      onBackdropClick={onBackdropClick}
    >
      <Container
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        sx={sx}
      >
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          <Typography variant="h2" fontWeight={600}>
            {title}
          </Typography>
          {description && <Typography variant="h3">{description}</Typography>}
        </Box>
        <Box display="flex" flexDirection="column" alignItems="center" gap={1} sx={{ width: "100%", ...childSx }}>
          {children}
        </Box>
        <Box display="flex" alignItems="center" gap={2}>
          {noAction && <Button variant="outlined" onClick={noAction}>
            {t('common:close')}
          </Button>}
          {yesAction && <Button variant="contained" onClick={yesAction}>
            <Typography fontWeight={600} color={t => t.palette.white.main}>
              {t('common:agree')}
            </Typography>
          </Button>}
        </Box>
      </Container>
    </Modal>
  );
}
